import React, { PropsWithChildren, ReactNode } from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import * as felaRules from './Callout.styles';

export interface CalloutProps extends PropsWithChildren {
    icon?: ReactNode;
    title?: string;
}

export const Callout = ({ icon, title, children }: CalloutProps) => {
    const { styles } = useFelaEnhanced(felaRules);
    return (
        <div className={styles.container} role="note">
            {Boolean(icon) && <div className={styles.icon}>{icon}</div>}
            <div>
                {Boolean(title) && <span className={styles.title}>{title}</span>}
                {children}
            </div>
        </div>
    );
};
